<template>
  <ValidationObserver v-slot="{ invalid }">
    <div class="ace-grain-beans-form ace-form">
      <h3 class="ace-form__title">Email me the results</h3>
      <div class="ace-form__intro">
        <p>Enter your details in the form below and we'll email over your report.</p>
      </div>
      <div class="ace-form__row">
        <div class="ace-form__field">
          <label for="full_name" class="ace-form__label">Full name (*)</label>
          <ValidationProvider name="Full name" rules="required" v-slot="{ classes, errors }">
            <input
              type="text"
              name="full_name"
              class="ace-form__input"
              :class="classes"
              v-model="customer.fullName"
            />
            <span>{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
      <div class="ace-form__row">
        <div class="ace-form__field">
          <label for="business_name" class="ace-form__label">Business name (*)</label>
          <ValidationProvider name="Business name" rules="required" v-slot="{ classes, errors }">
            <input
              type="text"
              name="business_name"
              class="ace-form__input"
              :class="classes"
              v-model="customer.businessName"
            />
            <span>{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div class="ace-form__field">
          <label for="business_email" class="ace-form__label">Business email (*)</label>
          <ValidationProvider
            name="Business email"
            rules="required|email"
            v-slot="{ classes, errors }"
          >
            <input
              type="text"
              name="business_email"
              class="ace-form__input"
              :class="classes"
              v-model="customer.businessEmail"
            />
            <span>{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
      <div class="ace-form__row">
        <div class="ace-form__field">
          <label for="country" class="ace-form__label">Country (*)</label>
          <div class="ace-form__input ace-form__input--select">
            <select id="country" name="country" v-model="customer.country">
              <option value="Ireland">Ireland</option>
              <option value="United Kingdom">United Kingdom</option>
              <option disabled>──────────</option>
              <option value="country" v-for="(country, key) in countries" :key="key">{{
                country
              }}</option>
            </select>
          </div>
        </div>
        <div class="ace-form__field">
          <label for="phone" class="ace-form__label">Phone</label>
          <ValidationProvider name="Phone" v-slot="{ errors }">
            <input type="text" name="phone" class="ace-form__input" v-model="customer.phone" />
            <span>{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
      <div class="ace-form__row">
        <div class="ace-form__field">
          <label class="ace-form__label">GDPR opt-in</label>
          <div class="ace-form__input ace-form__input--checkbox">
            <input
              type="checkbox"
              name="gdpr_opt_in"
              id="gdpr-opt-in"
              v-model="customer.gdprOptIn"
            />
            <label for="gdpr-opt-in">I'm happy to be contacted occasionally by Adesco</label>
          </div>
        </div>
      </div>
      <div class="ace-form__row">
        <div class="ace-form__actions">
          <Button variant="white" icon="cross" text="Cancel" @click="$emit('close')" />
          <Button
            variant="dark"
            :disabled="invalid"
            icon="arrow"
            text="Submit"
            @click="$emit('submit')"
          />
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend, configure } from 'vee-validate';

import { required, email } from 'vee-validate/dist/rules';

import Button from '../Layout/Button.vue';

import countries from '../_countries';

extend('required', required);
extend('email', email);

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
    dirty: 'is-dirty',
  },
});

export default {
  data() {
    return {
      countries,
    };
  },
  props: ['customer'],
  components: {
    Button,
    ValidationObserver,
    ValidationProvider,
  },
};
</script>

<style scoped lang="scss"></style>
